import React from 'react';
import classes from './dashboard-access-denied.module.scss';

// Themed denied state shown when a role lacks dashboard scope; mounts no polling hooks/providers.
export const DashboardAccessDenied: React.FC = () => (
  <main className={classes.page} dir="rtl">
    <div className={classes.card} data-testid="dashboard-access-denied">
      <h1 className={classes.title}>אין לך הרשאה לצפות בלוח הבקרה</h1>
      <p className={classes.subtitle}>פנה למנהל המערכת אם לדעתך נדרשת לך גישה.</p>
    </div>
  </main>
);
